export default function FileSearchIcon(props) {
  return (
    <svg
      width="140"
      height="129"
      viewBox="0 0 140 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2006_3009)">
        <path
          d="M67.3534 100.109C93.6621 100.109 114.991 78.7447 114.991 52.2976C114.991 25.8506 93.5682 4.48584 67.3534 4.48584C41.0447 4.48584 19.7158 25.8506 19.7158 52.2976C19.7158 78.7447 41.0447 100.109 67.3534 100.109Z"
          fill="#F8F4F9"
        />
        <path
          d="M111.89 20.9562C114.018 20.9562 115.742 19.2285 115.742 17.0973C115.742 14.9661 114.018 13.2385 111.89 13.2385C109.763 13.2385 108.038 14.9661 108.038 17.0973C108.038 19.2285 109.763 20.9562 111.89 20.9562Z"
          fill="#F8F4F9"
        />
        <path
          d="M117.528 5.89754C118.981 5.89754 120.158 4.71768 120.158 3.26225C120.158 1.80682 118.981 0.626953 117.528 0.626953C116.075 0.626953 114.897 1.80682 114.897 3.26225C114.897 4.71768 116.075 5.89754 117.528 5.89754Z"
          fill="#F8F4F9"
        />
        <path
          d="M22.2527 20.8621C23.7057 20.8621 24.8836 19.6823 24.8836 18.2268C24.8836 16.7714 23.7057 15.5916 22.2527 15.5916C20.7997 15.5916 19.6218 16.7714 19.6218 18.2268C19.6218 19.6823 20.7997 20.8621 22.2527 20.8621Z"
          fill="#F8F4F9"
        />
        <path
          d="M6.18571 71.6857C8.88412 71.6857 11.0716 69.4944 11.0716 66.7916C11.0716 64.0886 8.88412 61.8975 6.18571 61.8975C3.4873 61.8975 1.2998 64.0886 1.2998 66.7916C1.2998 69.4944 3.4873 71.6857 6.18571 71.6857Z"
          fill="#F8F4F9"
        />
        <g filter="url(#filter0_d_2006_3009)">
          <path
            d="M81.1655 26.8856L95.5411 78.6503C96.0109 80.4385 94.9773 82.2268 93.1924 82.6974L42.5481 96.1565C40.7628 96.627 38.9776 95.5917 38.5078 93.8032L20.8434 26.9797C20.3736 25.1915 21.4071 23.4032 23.1924 22.9326L59.8367 13.2385L81.1655 26.8856Z"
            fill="url(#paint0_linear_2006_3009)"
          />
        </g>
        <path
          d="M80.4138 59.6384L53.0716 66.8855L50.0648 67.6384L40.9508 70.0855C40.5749 70.1796 40.293 70.6502 40.481 71.1207C40.5749 71.5913 41.0447 71.8737 41.4206 71.7796L50.5346 69.3325L53.5414 68.5796L80.8836 61.3325C81.2595 61.2384 81.5414 60.7678 81.3534 60.2972C81.2595 59.8266 80.7897 59.5443 80.4138 59.6384Z"
          fill="#E8D6EB"
        />
        <path
          d="M78.6285 53.2385L68.4809 55.8738L65.0043 56.815L39.3533 63.6856C38.9775 63.7797 38.6956 64.2503 38.8835 64.7209C38.9775 65.1914 39.4473 65.4738 39.8231 65.3797L65.5681 58.5091L69.0446 57.5679L79.1923 54.9326C79.5681 54.8385 79.85 54.3679 79.6621 53.8973C79.4742 53.5209 79.0043 53.1444 78.6285 53.2385Z"
          fill="#E8D6EB"
        />
        <path
          d="M77.1252 46.7443L74.4944 47.4031L71.8635 48.062L37.5682 57.1914C37.1923 57.2855 36.9105 57.7561 37.0984 58.2267C37.1923 58.6973 37.6621 58.9796 38.038 58.8855L72.3333 49.7561L75.246 49.0031L77.595 48.3443C77.9709 48.2502 78.2527 47.7796 78.0648 47.309C77.9709 46.9325 77.595 46.6502 77.1252 46.7443Z"
          fill="#E8D6EB"
        />
        <path
          d="M61.2461 80.062L59.3669 80.5326C58.991 80.6267 58.5212 80.3444 58.4273 79.8738C58.3333 79.4032 58.5212 78.9326 58.8971 78.8385L60.7763 78.3679C61.1521 78.2738 61.6219 78.5561 61.7159 79.0267C61.8098 79.5914 61.6219 79.9679 61.2461 80.062Z"
          fill="#F8F4F9"
        />
        <path
          d="M55.5145 81.5679L44.7091 84.3914C44.3333 84.4855 43.8635 84.2032 43.7695 83.7326C43.6756 83.262 43.8635 82.7914 44.2393 82.6973L55.0447 79.8737C55.4206 79.7796 55.8904 80.062 55.9843 80.5326C56.1722 81.0032 55.9843 81.4737 55.5145 81.5679Z"
          fill="#E8D6EB"
        />
        <path
          d="M75.8099 40.2505L67.2596 42.5093L65.1925 43.074L35.971 50.7916C35.5952 50.8858 35.3133 51.3564 35.5012 51.8269C35.5952 52.2975 36.065 52.5799 36.4408 52.4858L65.5683 44.8622L67.6354 44.2975L76.0918 42.0387C76.5616 41.9446 76.7495 41.474 76.6556 40.9093C76.6556 40.5328 76.1858 40.1563 75.8099 40.2505Z"
          fill="#E8D6EB"
        />
        <path
          d="M55.6084 26.0385L31.3668 32.4385C30.803 32.6267 30.2392 32.2503 30.0513 31.6856C29.8634 31.1209 30.2392 30.5561 30.803 30.3679L55.0446 23.9679C55.6084 23.7797 56.1721 24.1561 56.3601 24.7209C56.548 25.2856 56.1721 25.8503 55.6084 26.0385Z"
          fill="#E8D6EB"
        />
        <path
          d="M42.2662 35.8268L32.9642 38.2739C32.4004 38.4621 31.8367 38.0857 31.6487 37.5209C31.4608 36.9562 31.8367 36.3915 32.4004 36.2033L41.6085 33.7562C42.1722 33.568 42.736 33.9445 42.9239 34.5092C43.1118 35.0739 42.736 35.6386 42.2662 35.8268Z"
          fill="#E8D6EB"
        />
        <path
          d="M59.8367 13.2385L63.5952 27.5444C64.1589 29.5209 66.32 30.7444 68.2931 30.1797L81.1656 26.8856"
          fill="#E8D6EB"
        />
        <g filter="url(#filter1_d_2006_3009)">
          <path
            d="M119.125 41.4739L110.481 94.5563C110.199 96.3447 108.413 97.5682 106.628 97.1918L55.1386 88.1563C53.3533 87.8739 52.1319 86.0857 52.4137 84.2974L64.3466 16.2504C64.6285 14.4622 66.4137 13.2386 68.199 13.6151L105.595 20.2033L119.125 41.4739Z"
            fill="url(#paint1_linear_2006_3009)"
          />
        </g>
        <path
          d="M104.749 70.9327L76.9372 66.0386L73.9305 65.4739L64.6285 63.8739C64.2527 63.7798 63.7829 64.1562 63.7829 64.6268C63.6889 65.0974 63.9708 65.568 64.3466 65.6621L73.6486 67.2621L76.6553 67.8268L104.467 72.721C104.843 72.8151 105.313 72.4386 105.313 71.968C105.407 71.4974 105.219 71.0268 104.749 70.9327Z"
          fill="#F8F4F9"
        />
        <path
          d="M105.877 64.4388L95.5413 62.6506L92.0649 61.9918L65.8502 57.38C65.4743 57.2859 65.0045 57.6624 65.0045 58.1329C64.9106 58.6035 65.1925 59.0741 65.5683 59.1682L91.7831 63.78L95.2594 64.4388L105.595 66.2271C105.971 66.3212 106.441 65.9447 106.441 65.4741C106.535 65.0035 106.253 64.5329 105.877 64.4388Z"
          fill="#F8F4F9"
        />
        <path
          d="M107.192 57.8504L104.468 57.3799L101.743 56.9093L66.7899 50.7916C66.414 50.6975 65.9442 51.074 65.9442 51.5446C65.8503 52.0152 66.1322 52.4857 66.508 52.5799L101.461 58.6975L104.468 59.2622L106.817 59.6387C107.192 59.7328 107.662 59.3563 107.662 58.8857C107.85 58.4152 107.662 57.9446 107.192 57.8504Z"
          fill="#F8F4F9"
        />
        <path
          d="M78.8166 81.474L76.9374 81.1917C76.5616 81.0975 76.2797 80.627 76.3737 80.1564C76.4676 79.6858 76.8435 79.3093 77.2193 79.4034L79.0985 79.6858C79.4743 79.7799 79.7562 80.2505 79.6623 80.7211C79.5683 81.2858 79.1925 81.474 78.8166 81.474Z"
          fill="#F8F4F9"
        />
        <path
          d="M73.0849 80.4385L62.0915 78.5562C61.7157 78.4621 61.4338 77.9915 61.5277 77.5209C61.6217 77.0503 61.9976 76.6738 62.3735 76.7679L73.3667 78.6503C73.7425 78.7444 74.0245 79.215 73.9305 79.6856C73.8365 80.2503 73.4607 80.5326 73.0849 80.4385Z"
          fill="#F8F4F9"
        />
        <path
          d="M108.695 51.4504L99.9572 49.9445L97.7961 49.5681L68.0112 44.2975C67.6353 44.2034 67.1654 44.5798 67.1654 45.0504C67.0715 45.521 67.3533 45.9916 67.7292 46.0857L97.5142 51.3563L99.6753 51.7328L108.32 53.2387C108.789 53.3328 109.165 52.9563 109.259 52.4857C109.353 52.0151 109.071 51.5445 108.695 51.4504Z"
          fill="#E8D6EB"
        />
        <path
          d="M96.3867 30.0856L71.6755 25.7561C71.1117 25.662 70.7359 25.0973 70.8298 24.5326C70.9238 23.9679 71.4875 23.5914 72.0513 23.6856L96.7625 28.015C97.3263 28.1091 97.7021 28.6738 97.6082 29.2385C97.5142 29.7091 96.9504 30.1797 96.3867 30.0856Z"
          fill="#E8D6EB"
        />
        <path
          d="M80.1319 33.2857L70.642 31.5916C70.0782 31.4975 69.7024 30.9328 69.7964 30.3681C69.8903 29.8034 70.4541 29.4269 71.0178 29.521L80.4138 31.2151C80.9776 31.3092 81.3534 31.8739 81.2595 32.4387C81.1655 33.0034 80.6017 33.3798 80.1319 33.2857Z"
          fill="#E8D6EB"
        />
        <path
          d="M105.501 20.2034L102.964 34.7916C102.588 36.8622 104.092 38.8387 106.159 39.2151L119.125 41.474"
          fill="#E8D6EB"
        />
        <path
          d="M83.7025 89.568C95.2743 89.568 104.655 80.1712 104.655 68.5798C104.655 56.9883 95.2743 47.5916 83.7025 47.5916C72.1305 47.5916 62.7495 56.9883 62.7495 68.5798C62.7495 80.1712 72.1305 89.568 83.7025 89.568Z"
          fill="white"
        />
        <path
          d="M81.7292 71.968C81.6352 71.5915 81.6352 71.2151 81.6352 70.7445C81.6352 69.1445 82.2929 67.7327 83.9842 66.5092L85.3936 65.4739C86.2392 64.8151 86.6151 64.0621 86.6151 63.1209C86.6151 61.8033 85.6755 60.4856 83.7023 60.4856C81.6352 60.4856 80.6956 62.1798 80.6956 63.7798C80.6956 64.1562 80.6956 64.4386 80.7896 64.7209L77.0312 64.6268C76.9372 64.2504 76.8433 63.7798 76.8433 63.3092C76.8433 60.1092 79.1923 57.0974 83.6084 57.0974C88.1184 57.0974 90.5614 60.0151 90.5614 62.9327C90.5614 65.2856 89.3399 66.8856 87.6486 68.1092L86.4272 68.9562C85.3936 69.7092 84.8298 70.6504 84.8298 71.7798V71.968H81.7292ZM83.3265 73.8504C84.6419 73.8504 85.6755 74.8856 85.6755 76.2033C85.6755 77.5209 84.6419 78.5562 83.3265 78.5562C82.011 78.5562 80.9775 77.5209 80.9775 76.2033C81.0714 74.9798 82.011 73.8504 83.3265 73.8504Z"
          fill="#90388B"
        />
        <path
          d="M115.066 101.166C114.252 101.166 113.44 100.841 112.788 100.107L99.2065 86.5026L98.7179 86.8284C94.3262 90.0871 89.2026 91.7979 83.9974 91.7979C77.735 91.7979 71.4725 89.2725 66.8366 84.8732C61.9568 80.2296 59.2729 73.9566 59.2729 67.1133C59.2729 53.5082 70.3339 42.4287 83.916 42.4287C93.1878 42.4287 101.321 47.3168 105.712 55.6265C110.023 63.8546 109.454 73.4678 104.168 81.2072L103.842 81.696L117.506 95.3828C118.888 96.7673 118.563 98.1527 118.319 98.8858C117.669 100.189 116.367 101.166 115.066 101.166ZM83.916 49.1905C73.9937 49.1905 66.0234 57.2558 66.0234 67.1133C66.0234 78.3558 75.2137 85.1176 84.1601 85.1176C89.6093 85.1176 94.5705 82.6736 98.0677 78.2744C102.379 72.8975 103.111 65.6469 100.101 59.3739C97.0107 53.1009 90.8292 49.1905 83.916 49.1905Z"
          fill="#90388B"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2006_3009"
          x="10.7302"
          y="7.23853"
          width="94.9241"
          height="103.031"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.909804 0 0 0 0 0.839216 0 0 0 0 0.921569 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2006_3009" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2006_3009"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2006_3009"
          x="42.3733"
          y="7.54688"
          width="86.7515"
          height="103.713"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.909804 0 0 0 0 0.839216 0 0 0 0 0.921569 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2006_3009" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2006_3009"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2006_3009"
          x1="58.1681"
          y1="11.318"
          x2="58.1681"
          y2="97.1643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.9964" stopColor="#F8F4F9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2006_3009"
          x1="85.7276"
          y1="11.6105"
          x2="85.7276"
          y2="98.1618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.9964" stopColor="#F8F4F9" />
        </linearGradient>
        <clipPath id="clip0_2006_3009">
          <rect width="140" height="128" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
